<img class="logo-img" [src]="navbarLogo" alt="Safe-guard-products" />

<div class="header-block">
  <h1>QUOTE</h1>
  <p>Printed: {{ date | date: 'shortDate' }}</p>
</div>

<div class="information-block">
  <div class="information-row heading">
    <p>Vehicle Information</p>
    <p>Dealer Information</p>
  </div>
  <div class="information-row">
    @if (vehicle(); as vehicle) {
      <div class="information-cell">
        <p>Vin: {{ vehicle.vin }}</p>
        <p>Make: {{ vehicle.make }}</p>
        <p>Model: {{ vehicle.model }}</p>
        <p>Year: {{ vehicle.year }}</p>
      </div>
    }
    @if (user(); as user) {
      <div class="information-cell">
        <p>{{ user.fullName }}</p>
        <p>{{ user.name }}</p>
        <p>{{ user.dealerInfo?.dealerAddress1 }}</p>
        <p>
          {{ user.dealerInfo?.dealerCity }}, {{ user.dealerInfo?.dealerState }} {{ user.dealerInfo?.dealerZipCode }}
        </p>
        <p>{{ user.dealerInfo?.dealerPhone }}</p>
      </div>
    }
  </div>
</div>

<div class="invoice-block">
  <div class="invoice-row heading">
    <span>Product</span>
    <span>Description</span>
    <span>Customer Price</span>
  </div>

  @for (item of cart(); track item; let i = $index; let last = $last) {
    @if (
      i !== 0 &&
      (i === amountOfContractOnFirstPage || (i - amountOfContractOnFirstPage) % amountOfContractOnRestPages === 0)
    ) {
      <div style="page-break-after: always"></div>
    }
    <div class="invoice-row">
      <span>{{ item.product.productDescription.enUsProductDescription }}</span>
      <span>
        {{ item.product.planName.enUsPlanName }} - {{ item.product.customerTerm }} MO
        @if (+item.product.termMileage !== 0) {
          <span>/{{ item.product.termMileage }} MILES</span>
        }
        , ${{ item.product.deductible }}
        DEDUCTIBLE
      </span>
      <span>${{ item.product.customerCost }}</span>
    </div>
  }
</div>

<p class="note">NOTE: Quote is subject to change at any time.</p>
